import React from 'react'
//import { Link } from 'react-router-dom'
import { Container, Typography, Box } from '@material-ui/core'
//import logo from './../logo.svg'
import logo from './../assets/images/adzkiya-games-logo.png'
import GameDatas from './../assets/data/GameData'
import GameSection from './../components/GameSection'
import Footer from '../components/partials/Footer'


function Home() {
  return (
    <>
    <Container maxWidth="md">
    <Box component="div" my={4}>  
    <Box alignItems="center" justifyContent="center" display="flex">
      <img src={logo} alt="Adzkiya Games Logo" width={256} height={256} />
      </Box>
      <Box alignItems="center" justifyContent="center" display="flex">
      <Typography variant="h2" fontWeigt="bold">
          Adzkiya Games
        </Typography>
      </Box>
    </Box>
      {/* <Link to="/profile">Menuju profile</Link> */}
    <GameSection games= {GameDatas}/>
    </Container>
    <Footer/>
    
    </>
  )
}

export default Home